var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "knowledge-base-detail" },
    [
      _c("div", { staticClass: "header-section" }, [
        _c("div", { staticClass: "title-wrapper" }, [
          _c(
            "div",
            { staticClass: "left-section" },
            [
              _c(
                "a-button",
                {
                  staticClass: "mr-3",
                  attrs: { icon: "arrow-left" },
                  on: { click: _vm.goBack },
                },
                [_vm._v(_vm._s(_vm.$t("voiceagent.back")))]
              ),
              _vm._v(" "),
              _vm.knowledgeBase
                ? _c("h1", { staticClass: "main-title" }, [
                    _vm._v(_vm._s(_vm.knowledgeBase.knowledge_base_name)),
                  ])
                : _vm._e(),
            ],
            1
          ),
          _vm._v(" "),
          _vm.knowledgeBase
            ? _c(
                "div",
                { staticClass: "status-section" },
                [
                  _c(
                    "a-tooltip",
                    {
                      attrs: {
                        title: _vm.$t("voiceagent.knowledgeBaseCompleted"),
                      },
                    },
                    [
                      _c("a-badge", {
                        attrs: {
                          status: _vm.getStatusBadge(_vm.knowledgeBase.status),
                          text: _vm.getStatusText(_vm.knowledgeBase.status),
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "a-tooltip",
                    {
                      attrs: {
                        title: _vm.knowledgeBase.enable_auto_refresh
                          ? _vm.$t("voiceagent.autoRefreshActive")
                          : _vm.$t("voiceagent.autoRefreshOff"),
                      },
                    },
                    [
                      _vm.knowledgeBase.enable_auto_refresh
                        ? _c(
                            "a-tag",
                            { attrs: { color: "blue" } },
                            [
                              _c("a-icon", { attrs: { type: "sync" } }),
                              _vm._v(
                                " " +
                                  _vm._s(_vm.$t("voiceagent.autoRefresh")) +
                                  "\n                    "
                              ),
                            ],
                            1
                          )
                        : _c(
                            "a-tag",
                            { attrs: { color: "orange" } },
                            [
                              _c("a-icon", { attrs: { type: "pause-circle" } }),
                              _vm._v(
                                " " +
                                  _vm._s(_vm.$t("voiceagent.manualRefresh")) +
                                  "\n                    "
                              ),
                            ],
                            1
                          ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
        ]),
        _vm._v(" "),
        _c("p", { staticClass: "title-description" }, [
          _vm._v(
            _vm._s(_vm.$t("voiceagent.knowledgeBaseDetailsAndSourceManagement"))
          ),
        ]),
      ]),
      _vm._v(" "),
      _c("a-spin", { attrs: { spinning: _vm.loading } }, [
        _vm.knowledgeBase
          ? _c("div", { staticClass: "section" }, [
              _c(
                "div",
                { staticClass: "sources-header" },
                [
                  _c("h2", [_vm._v(_vm._s(_vm.$t("voiceagent.sources")))]),
                  _vm._v(" "),
                  _c(
                    "a-button",
                    {
                      attrs: { type: "primary", icon: "plus" },
                      on: { click: _vm.showAddSourceModal },
                    },
                    [
                      _vm._v(
                        "\n                    " +
                          _vm._s(_vm.$t("voiceagent.addNewSource")) +
                          "\n                "
                      ),
                    ]
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "source-section" },
                [
                  _c("h3", [_vm._v(_vm._s(_vm.$t("voiceagent.urlSources")))]),
                  _vm._v(" "),
                  _c("a-table", {
                    attrs: {
                      columns: _vm.urlColumns,
                      dataSource: _vm.urlSources,
                      rowKey: "source_id",
                      pagination: { pageSize: 5 },
                      size: "middle",
                      locale: { emptyText: "URL kaynağı bulunmamaktadır" },
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "action",
                          fn: function (text, record) {
                            return [
                              _c("a-button", {
                                attrs: {
                                  type: "danger",
                                  shape: "circle",
                                  icon: "delete",
                                  size: "small",
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.deleteSource(
                                      _vm.knowledgeBase.knowledge_base_id,
                                      record.source_id
                                    )
                                  },
                                },
                              }),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      2769008180
                    ),
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "source-section" },
                [
                  _c("h3", [_vm._v("Dosya Kaynakları")]),
                  _vm._v(" "),
                  _c("a-table", {
                    attrs: {
                      columns: _vm.fileColumns,
                      dataSource: _vm.fileSources,
                      rowKey: "source_id",
                      pagination: { pageSize: 5 },
                      size: "middle",
                      locale: { emptyText: "Dosya kaynağı bulunmamaktadır" },
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "action",
                          fn: function (text, record) {
                            return [
                              _c("a-button", {
                                staticClass: "mr-2",
                                attrs: {
                                  type: "primary",
                                  shape: "circle",
                                  icon: "eye",
                                  size: "small",
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.openFileUrl(record.file_url)
                                  },
                                },
                              }),
                              _vm._v(" "),
                              _c("a-button", {
                                attrs: {
                                  type: "danger",
                                  shape: "circle",
                                  icon: "delete",
                                  size: "small",
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.deleteSource(
                                      _vm.knowledgeBase.knowledge_base_id,
                                      record.source_id
                                    )
                                  },
                                },
                              }),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      1245332907
                    ),
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "source-section" },
                [
                  _c("h3", [_vm._v("Metin Kaynakları")]),
                  _vm._v(" "),
                  _c("a-table", {
                    attrs: {
                      columns: _vm.textColumns,
                      dataSource: _vm.textSources,
                      rowKey: "source_id",
                      pagination: { pageSize: 5 },
                      size: "middle",
                      locale: { emptyText: "Metin kaynağı bulunmamaktadır" },
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "action",
                          fn: function (text, record) {
                            return [
                              _c("a-button", {
                                attrs: {
                                  type: "danger",
                                  shape: "circle",
                                  icon: "delete",
                                  size: "small",
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.deleteSource(
                                      _vm.knowledgeBase.knowledge_base_id,
                                      record.source_id
                                    )
                                  },
                                },
                              }),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      2769008180
                    ),
                  }),
                ],
                1
              ),
            ])
          : _vm._e(),
      ]),
      _vm._v(" "),
      _c(
        "a-modal",
        {
          attrs: { title: "Yeni Kaynak Ekle", footer: null, width: "700px" },
          on: { cancel: _vm.closeSourceModal },
          model: {
            value: _vm.showSourceModal,
            callback: function ($$v) {
              _vm.showSourceModal = $$v
            },
            expression: "showSourceModal",
          },
        },
        [
          _c(
            "a-tabs",
            { attrs: { "default-active-key": "url" } },
            [
              _c(
                "a-tab-pane",
                { key: "url", attrs: { tab: "URL Ekle" } },
                [
                  _c(
                    "a-form",
                    {
                      attrs: { form: _vm.urlForm, layout: "vertical" },
                      on: { submit: _vm.handleUrlSubmit },
                    },
                    [
                      _c(
                        "a-form-item",
                        {
                          attrs: {
                            label: "URL'ler (Her satıra bir URL ekleyin)",
                          },
                        },
                        [
                          _c("a-textarea", {
                            directives: [
                              {
                                name: "decorator",
                                rawName: "v-decorator",
                                value: [
                                  "knowledge_base_urls",
                                  {
                                    rules: [
                                      {
                                        required: true,
                                        message: "Lütfen en az bir URL girin",
                                      },
                                    ],
                                  },
                                ],
                                expression:
                                  "[\n                                'knowledge_base_urls',\n                                {\n                                    rules: [{ required: true, message: 'Lütfen en az bir URL girin' }]\n                                }\n                            ]",
                              },
                            ],
                            attrs: {
                              placeholder: "https://www.example.com",
                              rows: 4,
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "button-container" },
                        [
                          _c(
                            "a-button",
                            {
                              staticClass: "mr-2",
                              on: { click: _vm.closeSourceModal },
                            },
                            [
                              _vm._v(
                                "\n                            İptal\n                        "
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "a-button",
                            {
                              attrs: {
                                type: "primary",
                                "html-type": "submit",
                                loading: _vm.submitting,
                              },
                            },
                            [
                              _vm._v(
                                "\n                            Ekle\n                        "
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "a-tab-pane",
                { key: "file", attrs: { tab: "Dosya Yükle" } },
                [
                  _c(
                    "a-form",
                    {
                      attrs: { form: _vm.fileForm, layout: "vertical" },
                      on: { submit: _vm.handleFileSubmit },
                    },
                    [
                      _c(
                        "a-form-item",
                        { attrs: { label: "Dosya Yükle" } },
                        [
                          _c(
                            "a-upload-dragger",
                            {
                              attrs: {
                                name: "files",
                                multiple: true,
                                fileList: _vm.fileList,
                                beforeUpload: _vm.beforeUpload,
                              },
                              on: { change: _vm.handleFileChange },
                            },
                            [
                              _c(
                                "p",
                                { staticClass: "ant-upload-drag-icon" },
                                [_c("a-icon", { attrs: { type: "inbox" } })],
                                1
                              ),
                              _vm._v(" "),
                              _c("p", { staticClass: "ant-upload-text" }, [
                                _vm._v(
                                  "Dosyaları sürükleyip bırakın veya tıklayarak seçin"
                                ),
                              ]),
                              _vm._v(" "),
                              _c("p", { staticClass: "ant-upload-hint" }, [
                                _vm._v(
                                  "\n                                PDF, DOC, DOCX, TXT, CSV gibi dosyaları yükleyebilirsiniz\n                            "
                                ),
                              ]),
                            ]
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "button-container" },
                        [
                          _c(
                            "a-button",
                            {
                              staticClass: "mr-2",
                              on: { click: _vm.closeSourceModal },
                            },
                            [
                              _vm._v(
                                "\n                            İptal\n                        "
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "a-button",
                            {
                              attrs: {
                                type: "primary",
                                "html-type": "submit",
                                loading: _vm.submitting,
                                disabled: !_vm.fileList.length,
                              },
                            },
                            [
                              _vm._v(
                                "\n                            Ekle\n                        "
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "a-tab-pane",
                { key: "text", attrs: { tab: "Metin Ekle" } },
                [
                  _c(
                    "a-form",
                    {
                      attrs: { form: _vm.textForm, layout: "vertical" },
                      on: { submit: _vm.handleTextSubmit },
                    },
                    [
                      _vm._l(_vm.sourceTexts, function (text, index) {
                        return _c(
                          "div",
                          { key: index, staticClass: "text-item" },
                          [
                            _c(
                              "a-row",
                              { attrs: { gutter: 16 } },
                              [
                                _c(
                                  "a-col",
                                  { attrs: { span: 8 } },
                                  [
                                    _c(
                                      "a-form-item",
                                      {
                                        attrs: {
                                          label: "Başlık",
                                          required: true,
                                        },
                                      },
                                      [
                                        _c("a-input", {
                                          attrs: { placeholder: "Başlık" },
                                          model: {
                                            value: text.title,
                                            callback: function ($$v) {
                                              _vm.$set(text, "title", $$v)
                                            },
                                            expression: "text.title",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "a-col",
                                  { attrs: { span: 14 } },
                                  [
                                    _c(
                                      "a-form-item",
                                      {
                                        attrs: {
                                          label: "Metin İçeriği",
                                          required: true,
                                        },
                                      },
                                      [
                                        _c("a-textarea", {
                                          attrs: {
                                            placeholder: "Metin İçeriği",
                                            rows: 3,
                                          },
                                          model: {
                                            value: text.text,
                                            callback: function ($$v) {
                                              _vm.$set(text, "text", $$v)
                                            },
                                            expression: "text.text",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "a-col",
                                  {
                                    staticStyle: {
                                      display: "flex",
                                      "align-items": "center",
                                      "padding-top": "40px",
                                    },
                                    attrs: { span: 2 },
                                  },
                                  [
                                    _c("a-button", {
                                      attrs: {
                                        shape: "circle",
                                        type: "danger",
                                        icon: "delete",
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.removeSourceText(index)
                                        },
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        )
                      }),
                      _vm._v(" "),
                      _c(
                        "a-button",
                        {
                          staticClass: "mb-3",
                          attrs: { type: "dashed", block: "" },
                          on: { click: _vm.addSourceText },
                        },
                        [
                          _c("a-icon", { attrs: { type: "plus" } }),
                          _vm._v(" Metin Ekle\n                    "),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "button-container" },
                        [
                          _c(
                            "a-button",
                            {
                              staticClass: "mr-2",
                              on: { click: _vm.closeSourceModal },
                            },
                            [
                              _vm._v(
                                "\n                            İptal\n                        "
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "a-button",
                            {
                              attrs: {
                                type: "primary",
                                "html-type": "submit",
                                loading: _vm.submitting,
                                disabled: !_vm.isValidText,
                              },
                            },
                            [
                              _vm._v(
                                "\n                            Ekle\n                        "
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                    ],
                    2
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }